import styled from 'styled-components'

export const OptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`

export const OptionInput = styled.div`
  flex: 1;
  min-width: 0;
`

const linkButton = `
  border: none;
  background: transparent;
  padding: 0;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  transition: opacity 200ms ease;

  &:hover:not(:disabled) {
    opacity: 0.7;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 4px #002a6d3d, 0 1px 2px 0 #0e0e0e0a;
  }

  &:disabled {
    opacity: 0.48;
    cursor: not-allowed;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const RemoveButton = styled.button`
  ${linkButton}
  width: 26px;
  height: 26px;
  border-radius: 4px;
  color: #757575;
  font-size: 14px;
`

/** Keeps the inputs aligned when a row has no remove button. */
export const RemovePlaceholder = styled.span`
  width: 26px;
  flex-shrink: 0;
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 4px;
`

export const AddButton = styled.button`
  ${linkButton}
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #0669f5;
`

export const Counter = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  line-height: 16px;
  color: #757575;
`
